module.exports = __webpack_public_path__ + "img/testimonial-who-3.b301e94.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/testimonial-who-3.png
// module id = ./assets/img/testimonial-who-3.png
// module chunks = 2 3 4 5 6